


export class AppMessageEvent {
    constructor(public message: string, 
            public source: any, 
            public type: string, 
            public expireSeconds : number = 5*60 ) {}
}

export class AppErrorMessageEvent extends AppMessageEvent {
    error : any //place to attach exception if needed
    stack : string //place to add stack if error is not instance of Error w/stack
    public static readonly DEFAULT_EXPIRE_SECS = 0;
    constructor(message: string, source: any, expireSecs : number = AppErrorMessageEvent.DEFAULT_EXPIRE_SECS) {
        super(message,source,'error',expireSecs)
    }
}

export class AppWarningMessageEvent extends AppMessageEvent {
    public static readonly DEFAULT_EXPIRE_SECS = 1*60;
    constructor(message: string, source: any, expireSecs : number = AppInfoMessageEvent.DEFAULT_EXPIRE_SECS) {
        super(message,source,'warning',expireSecs)
    }
}

export class AppSuccessMessageEvent extends AppMessageEvent {
    public static readonly DEFAULT_EXPIRE_SECS = 5*60;
    constructor(message: string, source: any, expireSecs : number = AppSuccessMessageEvent.DEFAULT_EXPIRE_SECS) {
        super(message,source,'success',expireSecs)
    }
}

export class AppInfoMessageEvent extends AppMessageEvent {
    public static readonly DEFAULT_EXPIRE_SECS = 1*60;
    constructor(message: string, source: any, expireSecs : number = AppInfoMessageEvent.DEFAULT_EXPIRE_SECS) {
        super(message,source,'info',expireSecs)
    }
}
